import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { ReducerState } from "../../types";
import TrapTable from "../../components/Traps/index";
import DeviceSetup from "../../components/DeviceSetup";
import "./index.css";
import { displayErrorNotification } from "../../actions";
import { useBluetooth } from "../../providers/bluetoothProvider";
import { Typography } from "antd";

const { Title } = Typography;

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, { displayErrorNotification });

type Props = ConnectedProps<typeof connector>;

const Traps: React.FC<Props> = ({ displayErrorNotification }) => {
  const handleSendErrorMessage = (msg: string) => {
    displayErrorNotification(msg);
  };

  const {
    connect,
    disconnect,
    connected,
    bluetoothState,
    scanWifi,
    startWifiConnect,
    isWifiConnected,
    currentNetwork,
  } = useBluetooth({ handleSendErrorMessage });

  const handleConnect = async (deviceUuid: string) => {
    try {
      const success = await connect();
      if (!success) {
        displayErrorNotification(
          `Failed to connect to ${deviceUuid}. Please refresh the page and try again.`,
        );
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  return (
    <div className="px-6 h-full w-full">
      <Title level={2} className="my-6">
        Traps
      </Title>
      <TrapTable />
      <DeviceSetup
        handleConnect={handleConnect}
        disconnect={disconnect}
        connected={connected}
        bluetoothState={bluetoothState}
        scanWifi={scanWifi}
        startWifiConnect={startWifiConnect}
        isWifiConnected={isWifiConnected}
        currentNetwork={currentNetwork}
      />
    </div>
  );
};

export default connector(Traps);
